import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

export default function TermsOfServicePage() {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      
      <main className="flex-1 bg-white">
        <div className="max-w-4xl mx-auto px-6 py-20">
          <h1 className="text-4xl font-bold text-gray-900 mb-8">Terms of Service</h1>
          
          <div className="prose prose-lg max-w-none">
            <p className="text-gray-600 mb-8">
              These Terms of Service ("Terms") govern your access to and use of the website, services, and consulting engagements provided by CEB Consulting Inc. ("CEB Consulting", "we", "us", or "our"). By accessing our website or engaging our services, you agree to be bound by these Terms. If you do not agree, you must not use our website or services.
            </p>

            <section className="mb-10">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">1. Services</h2>
              <p className="text-gray-600 leading-relaxed">
                CEB Consulting Inc. provides professional consulting, advisory, and related business services. All services are provided subject to availability and may be governed by separate written agreements, proposals, or statements of work. In the event of a conflict, those written agreements shall prevail.
              </p>
            </section>

            <section className="mb-10">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">2. No Professional Guarantee</h2>
              <p className="text-gray-600 leading-relaxed">
                While we strive to provide high-quality consulting services, CEB Consulting does not guarantee specific results, outcomes, or financial performance. Any recommendations, forecasts, or opinions provided are based on information available at the time and should not be construed as guarantees.
              </p>
            </section>

            <section className="mb-10">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">3. Client Responsibilities</h2>
              <p className="text-gray-600 leading-relaxed mb-4">You agree to:</p>
              <ul className="list-disc pl-6 space-y-2 text-gray-600">
                <li>Provide accurate, complete, and timely information necessary for us to perform the services</li>
                <li>Use our services only for lawful purposes</li>
                <li>Comply with all applicable laws, regulations, and industry standards</li>
              </ul>
              <p className="text-gray-600 leading-relaxed mt-4">
                CEB Consulting is not responsible for outcomes resulting from inaccurate or incomplete information provided by you.
              </p>
            </section>

            <section className="mb-10">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">4. Fees and Payment</h2>
              <p className="text-gray-600 leading-relaxed mb-4">
                Fees, billing schedules, and payment terms will be outlined in written proposals, contracts, or invoices. Unless otherwise stated:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-gray-600">
                <li>All fees are payable in Canadian dollars (CAD)</li>
                <li>Invoices are due upon receipt or within the timeframe specified</li>
                <li>Late payments may result in suspension of services</li>
              </ul>
            </section>

            <section className="mb-10">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">5. Intellectual Property</h2>
              <p className="text-gray-600 leading-relaxed">
                All materials, methodologies, reports, content, and deliverables created by CEB Consulting remain our intellectual property unless otherwise agreed in writing. You are granted a limited, non-transferable license to use deliverables solely for your internal business purposes.
              </p>
            </section>

            <section className="mb-10">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">6. Website Use</h2>
              <p className="text-gray-600 leading-relaxed mb-4">You agree not to:</p>
              <ul className="list-disc pl-6 space-y-2 text-gray-600">
                <li>Use the website in a way that could damage, disable, or impair its operation</li>
                <li>Attempt to gain unauthorized access to any systems or data</li>
                <li>Copy, reproduce, or distribute website content without prior written consent</li>
              </ul>
              <p className="text-gray-600 leading-relaxed mt-4">
                All website content is provided for general informational purposes only.
              </p>
            </section>

            <section className="mb-10">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">7. Confidentiality</h2>
              <p className="text-gray-600 leading-relaxed">
                Both parties agree to keep confidential any non-public, proprietary, or confidential information disclosed during the course of the engagement, except where disclosure is required by law or permitted in writing.
              </p>
            </section>

            <section className="mb-10">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">8. Limitation of Liability</h2>
              <p className="text-gray-600 leading-relaxed mb-4">
                To the maximum extent permitted by law, CEB Consulting shall not be liable for any indirect, incidental, consequential, special, or punitive damages, including loss of profits, revenue, or data, arising out of or related to the use of our website or services.
              </p>
              <p className="text-gray-600 leading-relaxed">
                Our total liability for any claim shall not exceed the fees paid to CEB Consulting for the services giving rise to the claim.
              </p>
            </section>

            <section className="mb-10">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">9. Indemnification</h2>
              <p className="text-gray-600 leading-relaxed">
                You agree to indemnify and hold harmless CEB Consulting Inc., its directors, officers, employees, and contractors from any claims, liabilities, damages, losses, or expenses arising from your misuse of our services or breach of these Terms.
              </p>
            </section>

            <section className="mb-10">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">10. Termination</h2>
              <p className="text-gray-600 leading-relaxed">
                We reserve the right to suspend or terminate access to our website or services at any time for breach of these Terms or applicable law. Termination does not relieve you of payment obligations incurred prior to termination.
              </p>
            </section>

            <section className="mb-10">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">11. Third-Party Links</h2>
              <p className="text-gray-600 leading-relaxed">
                Our website may contain links to third-party websites. We are not responsible for the content, policies, or practices of third-party sites, and access to them is at your own risk.
              </p>
            </section>

            <section className="mb-10">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">12. Governing Law</h2>
              <p className="text-gray-600 leading-relaxed">
                These Terms shall be governed by and construed in accordance with the laws of the Province of Ontario and the federal laws of Canada applicable therein.
              </p>
            </section>

            <section className="mb-10">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">13. Changes to These Terms</h2>
              <p className="text-gray-600 leading-relaxed">
                We may update these Terms from time to time. Changes will be effective upon posting on our website. Continued use of our website or services constitutes acceptance of the revised Terms.
              </p>
            </section>

            <section className="mb-10">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">14. Contact Information</h2>
              <div className="bg-teal-50 border-l-4 border-teal-600 p-6 rounded-lg">
                <p className="text-gray-600 leading-relaxed mb-2">
                  If you have questions regarding these Terms of Service, please contact:
                </p>
                <p className="font-semibold text-gray-900">CEB Consulting Inc.</p>
                <p className="text-gray-600">5915 Leslie St</p>
                <p className="text-gray-600">North York, ON M2H 1J8</p>
                <p className="text-gray-600">Canada</p>
                <p className="text-gray-600">Email: info@cebconsultinginc.com</p>
              </div>
            </section>

            <div className="bg-gray-50 border border-gray-200 p-6 rounded-lg mt-10">
              <p className="text-gray-600 leading-relaxed">
                By using our website or services, you acknowledge that you have read, understood, and agree to these Terms of Service.
              </p>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
